import yaml, {YAMLException} from "js-yaml";
import {CustomMarkers} from "@/lib/editor";

export const ValidateYAML = (yamlString: string): Array<CustomMarkers>| undefined  => {
    try{
        yaml.load(yamlString);
    }
    catch(error){
        if(error instanceof YAMLException){
            if(!!error.mark){
                const errorMarkers = getMarkerValues(error);
                console.log(errorMarkers, error);
                if(!!errorMarkers) {
                    return [errorMarkers];
                }
            }
        }
    }
}


export const getMarkerValues = (error: YAMLException): CustomMarkers|undefined => {
    const regExp = /\(([^)]+)\)/;
    const messageRegEx = /.*\s*:\s*.*/g;
    const lineCol = regExp.exec(error.message);
    if(!lineCol || lineCol.length <1){
        return ;
    }

    return {
        line: Number(lineCol[1].split(":")[0]),
        column: Number(lineCol[1].split(":")[1]),
        message: error.reason
    };
}
